module.exports = __webpack_public_path__ + "static/img/video_icon3_1.057fe2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon3_1.png
// module id = kRwT
// module chunks = 0